<template>
    <div class="aba-produto">
        <container-loader v-if="isLoading && !$store.getters.isLoading" />
        <div class="vertical-flow">
            <div class="columns">
                <div class="column">
                    <search-bar
                        :onSearch="debouncedOnSearch"
                        tooltipLabel="msg-toltip-aba-empresa"
                    />
                </div>

                <div class="column" :class="[permissao.create ? 'is-2' : 'is-4']">
                    <vss-select
                        ref="situacaoSelect"
                        :searchable="false"
                        :options="situacaoSelect"
                        v-model="situacaoSelected"
                        mlLabels
                        title="situacao"
                        clearable
                        @input="onSituacaoChanged"
                        :height="40"
                    />
                </div>

                <div class="column is-3" v-if="permissao.create && !assProdutoEmpresaIntegracao">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="showModalVincularEmpresa"
                    >
                        {{ $t('vincular-empresa') }}
                    </button>
                </div>
                <!-- Botao vai para a tela de cadastro de empresa, e a função para 
                  voltar para a tela atual está na AbaDadosCadastrais e Geral de empresa -->
                <div class="column is-3" v-if="permissaoEmpresa.create && !empresaIntegracao">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="
                            $router.push({
                                name: 'ven-empresa-dados-cadastrais-new',
                                query: {
                                    tela: 'produto-empresa',
                                    id: $route.params.id,
                                    dadoscadastrais: 1,
                                    politicacomercial: $route.query.politicacomercial
                                        ? $route.query.politicacomercial
                                        : null,
                                    analisecomercial: $route.query.analisecomercial
                                        ? $route.query.analisecomercial
                                        : null,
                                },
                            })
                        "
                    >
                        {{ $t('adicionar-empresa') }}
                    </button>
                </div>
            </div>

            <div class="registry-wrapper">
                <empty-table-message v-if="isEmpty" />
                <b-table
                    v-else
                    :data="assprodutoempresa"
                    class="data-table"
                    @sort="sortTable"
                    backend-sorting
                >
                    <b-table-column
                        v-for="(f, i) in fields"
                        :key="i"
                        :field="f.key"
                        :label="f.key != 'excluir' ? $t(f.key) : ''"
                        :width="f.width"
                        :class="{
                            'excluir-field': f.key == 'excluir',
                        }"
                        :sortable="f.sortable"
                        :custom-sort="f.sortFn"
                        v-slot="props"
                    >
                        <div v-if="f.key == 'excluir'">
                            <b-button
                                v-if="permissao.delete && !assProdutoEmpresaIntegracao"
                                class="action-button"
                                :type="
                                    props.row['replicapda'] == 3
                                        ? 'is-danger'
                                        : 'is-success'
                                "
                                :icon-right="
                                    props.row['replicapda'] == 3 ? 'delete' : 'check'
                                "
                                @click="promptChangeSituacao(props.row)"
                                v-tippy 
                                :title="$t(props.row['replicapda'] == 3 ? 'desativar' : 'reativar')"
                            />
                        </div>
                        <div v-else-if="f.key == 'replicapda'">
                            <b-tag
                                class="table-tag table-tag-full-width"
                                :type="props.row['replicapda'] == 3 ? 'is-success' : 'is-danger'"
                                size="is-medium"
                            >
                                {{ $t(props.row['replicapda'] == 3 ? 'ativo' : 'inativo') }}
                            </b-tag>
                        </div>
                        <div v-else-if="f.key == 'nome'">
                            <a
                                @click="selectedEmpresa(props.row)"
                                v-if="permissaoEmpresa.create && !empresaIntegracao"
                            >
                                {{ props.row[f.key] }}
                            </a>
                        </div>
                        <div v-else>
                            {{ props.row[f.key] }}
                        </div>
                    </b-table-column>
                </b-table>
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>

            <!-- MODAL DE ASSOCIACAO -->
            <b-modal :active.sync="showModalAssociacao">
                <div class="bg">
                    <EmpresaModal
                        :idProduto="$route.params.id"
                        @fecharModal="fecharModal"
                        :selected="assPacoteProdutoSelected"
                    />
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
// SERVICES
import AssProdutoEmpresaService from '@/services/vendas/empresa/abas/AssProdutoEmpresaService';
import EmpresaModal from '@/components/vendas/produto/modal/EmpresaModal.vue';

// COMPONENTS
import ContainerLoader from '@/components/content/loader/ContainerLoader';

export default {
    components: {
        ContainerLoader,
        EmpresaModal,
    },
    data() {
        return {
            assProdutoEmpresaIntegracao: this.$store.state.user.tabelasERPWebServer.includes(
                'ASSPRODUTOEMPRESA'
            ),
            empresaIntegracao: this.$store.state.user.tabelasERPWebServer.includes('EMPRESA'),
            assprodutoempresa: [],
            fields: [
                { key: 'nome', width: null, sortable: true, sortFn: null },
                { key: 'multiplicadorweb', width: null, sortable: true, sortFn: null },
                { key: 'multiplicadortrocaweb', width: null, sortable: true, sortFn: null },
                { key: 'codigo', width: null, sortable: true, sortFn: null },
                { key: 'rsocial', width: null, sortable: true, sortFn: null },
                { key: 'ie', width: null, sortable: true, sortFn: null },
                { key: 'replicapda', width: 80, sortable: true, sortFn: null },
                { key: 'excluir', width: 70, sortable: true, sortFn: null },
            ],

            service: new AssProdutoEmpresaService(this.$http, this.$router),
            permissao: false,
            permissaoEmpresa: false,
            assPacoteProdutoSelected: null,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            situacaoSelected: { id: 4, label: 'todos' },
            situacaoSelect: [
                { id: 4, label: 'todos' },
                { id: 3, label: 'ativos' },
                { id: 2, label: 'inativos' },
            ],
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            queryFilter: '',
            column: 'nome',
            order: 'asc',
            isSaving: false,
            delete: null,
            showModalAssociacao: false,
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        this.permissao = this.hasPermissionAccess(
            'vendas',
            'produtos',
            'ven-produto-dados-cadastrais-empresa'
        );

        this.permissaoEmpresa = this.hasPermissionAccess(
            'vendas',
            'empresa',
            'ven-empresa-dados-cadastrais'
        );

        !this.permissao.read &&
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'aba-empresa' },
            });

        this.carregarDados();
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
    },
    methods: {
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;

            this.service
                .findByIdProduto(
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.situacaoSelected.id,
                    this.$route.params.id,
                    this.queryFilter
                )
                .then(this.mapItems)
                .then((value) => {
                    this.assprodutoempresa = value;
                    this.isEmpty = this.assprodutoempresa.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os usuários!');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map((m) => {
                return {
                    idassprodutoempresa: m.idassprodutoempresa,
                    codigo: m.empresa.idempresaerp,
                    nome: m.empresa.nome,
                    multiplicadorweb: m.multiplicadorweb,
                    multiplicadortrocaweb: m.multiplicadortrocaweb,
                    rsocial: m.empresa.rsocial,
                    ie: m.empresa.ie,
                    replicapda: m.replicapda,
                };
            });
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        selectedEmpresa(selected) {
            this.assPacoteProdutoSelected = selected;
            this.showModalAssociacao = true;
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        onSituacaoChanged(val) {
            this.situacaoSelected = val
                ? this.situacaoSelect.filter((v) => v.id == val.id)[0]
                : this.situacaoSelect[0];
            this.carregarDados();
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.replicapda == 3
                        ? 'msg-confirmacao-desativacao-n'
                        : 'msg-confirmacao-reativacao-n', 
                    { n: row['nome'] }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacaoRegistro() {
            let tempFailure = this.$t(
                    this.delete.replicapda == 3
                        ? 'msg-erro-ao-reativar-n'
                        : 'msg-erro-ao-desativar-n', 
                    { n: this.$t('associacao-empresa') }
                );

            let tempAssProdutoEmpresa = {
                idassprodutoempresa: this.delete.idassprodutoempresa,
                replicapda: this.delete.replicapda == 3 ? 2 : 3,
            };

            this.isLoading = true;

            this.service
                .updateSituacaoVendas(tempAssProdutoEmpresa)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess = this.$t(
                            r.content.replicapda == 3
                                ? 'msg-sucesso-ao-reativar-n'
                                : 'msg-sucesso-ao-desativar-n', { n: this.$t('associacao-empresa') }
                        );
                        this.$root.showMessage('success', tempSuccess, true, false);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage('error', 'Erro ao atualizar status.');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao atualizar status.', e);
                    this.$root.showMessage('error', tempFailure, true, false);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        showModalVincularEmpresa() {
            this.showModalAssociacao = !this.showModalAssociacao;
        },
        fecharModal() {
            this.assPacoteProdutoSelected = null;
            this.showModalAssociacao = false;
            this.carregarDados();
        },
    },
};
</script>

<style lang="scss" scoped>
.aba-produto {
    height: 100%;

    .botao-acao {
        margin-top: 24px;
        width: 100%;
        height: 40px;
    }

    @media (max-width: 760px) {
        .search-bar {
            padding-bottom: 0.4rem;
        }
        .botao-acao {
            margin-top: 0;
        }
    }
}
</style>
